<template>
  <b-row>
    <b-col cols="12">
      <WebexTokenIndex :routeName="$route.name"/>
      
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import WebexTokenIndex from './WebexTokenIndex.vue'
import WebexTokenManage from './WebexTokenManage.vue'

export default {
  components: {
    BRow,
    BCol,
    WebexTokenIndex,
    WebexTokenManage
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
